import { read } from './vault.http'
import { id, object } from '@/services/legalControl/workflow'
export interface NavigationTarget {
  client_id: string
  display_name: string
}
export interface NavigationTargets {
  clients: NavigationTarget[]
  next_after: string | null
  authority_granted: false
}
export async function navigationTargets(after: string | null = null): Promise<NavigationTargets> {
  if (after !== null && id(after) !== after) throw new Error('Exact navigation cursor required')
  const value = object(
    await read<unknown>('/clients/vault-targets', { page_size: 50, ...(after ? { after } : {}) })
  )
  if (
    Object.keys(value).sort().join(',') !== 'authority_granted,clients,next_after' ||
    value.authority_granted !== false ||
    !Array.isArray(value.clients) ||
    value.clients.length > 50
  )
    throw new Error('Current assigned Vault choices unavailable')
  let previous = after ?? ''
  const clients = value.clients.map(value => {
    const row = object(value),
      selected = id(row.client_id)
    if (
      Object.keys(row).sort().join(',') !== 'client_id,display_name' ||
      selected !== row.client_id ||
      selected <= previous ||
      typeof row.display_name !== 'string' ||
      !row.display_name.trim() ||
      row.display_name !== row.display_name.trim() ||
      row.display_name.length > 255
    )
      throw new Error('Exact assigned Vault target required')
    previous = selected
    return { client_id: selected, display_name: row.display_name }
  })
  const cursor = value.next_after
  if (
    cursor !== null &&
    (typeof cursor !== 'string' ||
      id(cursor) !== cursor ||
      clients.length !== 50 ||
      cursor !== previous)
  )
    throw new Error('Exact next navigation cursor required')
  return { clients, next_after: cursor as string | null, authority_granted: false }
}
